import clsx from 'clsx';
import styles from './styles.module.scss';

type BottomSheetItemProps = {
  title: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
  className?: string;
};

const BottomSheetItem: React.FC<BottomSheetItemProps> = (props) => {
  const { title, onClick, variant, className } = props;

  return (
    <li
      className={clsx(styles.item, variant === 'danger' && styles.danger, className)}
      onClick={onClick}
    >
      {title}
    </li>
  );
};

export default BottomSheetItem;
